import React from 'react';

export const uppercaseInputValue: React.FormEventHandler<HTMLInputElement> = (e) => {
  const target = e.target as HTMLInputElement;
  target.value = target.value.toUpperCase();
};
